'use client'

import NotFound from '@/shared/components/not-found/NotFound';
import { TbHeartBroken } from 'react-icons/tb';

export default function BusinessNotFound() {
    return (
        <NotFound
            icon={TbHeartBroken}
            title="Page Not Found"
            description="The page you are looking for could not be found. Please check the URL and try again."
            action={{
                label: 'Back to Home',
                href: '/'
            }}
        />
    );
}